import React from 'react'
import DwellDetailedViewTableData from "./DwellDetailedViewTableData";

const DwellDetailedView = (props) => {
        return (
                  <DwellDetailedViewTableData location={props.location} selectedTabForPackages={props.selectedTabForPackages}/>
        )
}

export default DwellDetailedView;


// WEBPACK FOOTER //
// ./src/components/dwellRush/DwellDetailedView.js